import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const ScrollContainer = styled.div<{showLeftFade: boolean; showRightFade: boolean}>`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 10px 0;
  scroll-snap-type: x mandatory;
  cursor: grab;
  transition: mask-image 0.3s ease;

  /* Hide scrollbar */
  &::-webkit-scrollbar {
    display: none;
  }

  user-select: none;

  mask-image: ${({ showLeftFade, showRightFade }) =>
    `
    linear-gradient(
      to right,
      ${showLeftFade ? 'transparent' : 'black'} 0%,
      black ${showLeftFade ? '10%' : '0%'},
      black ${showRightFade ? '90%' : '100%'},
      ${showRightFade ? 'transparent' : 'black'} 100%
    )
  `};
  mask-repeat: no-repeat;
  mask-size: 100% 100%;

  -webkit-mask-image: ${({ showLeftFade, showRightFade }) =>
    `
    linear-gradient(
      to right,
      ${showLeftFade ? 'transparent' : 'black'} 0%,
      black ${showLeftFade ? '10%' : '0%'},
      black ${showRightFade ? '90%' : '100%'},
      ${showRightFade ? 'transparent' : 'black'} 100%
    )
  `};
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
`;

export const Image = styled.img`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  object-fit: cover;
  z-index: -1;

  ${mediaQuery.maxWidth.tablet} {
    height: 100%;
  }
`;

export const AuraImage = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  object-fit: fill;
  z-index: -2;
  opacity: 0.5;
  transition: opacity 0.3s ease; 

  ${mediaQuery.maxWidth.tablet} {
    height: 100%;
  }
`;

export const Card = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.30);
  backdrop-filter: blur(25px);
  padding: 32px 32px 32px 24px;
  height: 474px;
  min-width: 346px;
  max-width: 346px;
  margin-right: 15px;
  border-radius: 12px;
  overflow: hidden;
  padding: 20px 20px 10px;
  scroll-snap-align: start;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.01) 100%); 

  ${mediaQuery.maxWidth.tablet} {
    flex: 0 0 90%;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 2rem;
  font-style: normal;
  font-weight: 700;
  letter-spacing: -0.32px;

  ${mediaQuery.maxWidth.tablet} {
    font-size: 1.25rem;
  }
`;

export const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.white75};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const ButtonLink = styled.div`
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: rgba(255, 255, 255, 0.10);
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);
  border-radius: 48px;
  padding: 12px 32px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  text-transform: uppercase;
  width: 100%;
  a,
  span {
    text-decoration: none;
    font-family: ${({ theme }) => theme.fontFamily.bold};
    letter-spacing: 1px;
    font-size: 1rem;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.white};

    ${mediaQuery.maxWidth.tablet} {
      font-size: 0.75rem;
    }
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    & ~ ${AuraImage} {
      opacity: 1;
    }
  }
`;

export const ButtonContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  pointer-events: none;
  margin-top: 10px;
  ${mediaQuery.maxWidth.tablet} {
    display: none;
  }
`;

export const ScrollButton = styled.button<{ disabled: boolean }>`
  color: white;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  cursor: ${({ disabled }) => (disabled ? 'none' : 'pointer')};
  pointer-events: all;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
`;
